const config = {
    zoomLevel: 18,
    latitudeForFocusingMap: 29.628154,
    longitudeForFocusingMap: 52.526928,
    markerLongitude: 52.526928,
    markerLatitude: 29.628154,
    apiKey: 'AIzaSyArYtTmvPoeuN7B8YNq22tu1jvQOBHY5RY',
    useDefaultUI: false,
    googleMapsMarkerIcon: '/image/marker.png'
}

export default config;